import LinkifyIt from 'linkify-it';

// LinkifyIt doesn't allow underscores `_` inside subdomains
// saying it might add false positives :(
// The only way to extend it is to use `onCompile`
// however, since most of the regular expressions are dependent on one another
// and regexps are constructed before `onCompile` is called, we need to override all
// derivative expressions.
// This change is added with all the test cases of linkify-it valid and invalid links.
// Hopefully this will not be needed util https://github.com/markdown-it/linkify-it/pull/96 is merged
// Resolves https://jira.wixpress.com/browse/RICH-1410
LinkifyIt.prototype.onCompile = function () {
  const re = this.re;
  const text_separators = '[><\uff5c]';

  re.src_domain =
    '(?:' +
    re.src_xn +
    '|' +
    '(?:' +
    re.src_pseudo_letter +
    ')' +
    '|' +
    // The only difference from original source is added `_|` here:
    // ----------------------------------v
    '(?:' +
    re.src_pseudo_letter +
    '(?:-|_|' +
    re.src_pseudo_letter +
    '){0,61}' +
    re.src_pseudo_letter +
    ')' +
    ')';

  re.src_host = '(?:(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain /* _root */ + '))';

  re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%)))';

  re.src_host_strict = re.src_host + re.src_host_terminator;

  re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;

  re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;

  re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;

  re.tpl_email_fuzzy =
    '(^|' +
    text_separators +
    '|"|\\(|' +
    re.src_ZCc +
    ')' +
    '(' +
    re.src_email_name +
    '@' +
    re.tpl_host_fuzzy_strict +
    ')';

  re.tpl_link_fuzzy =
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' +
    re.src_ZPCc +
    '))' +
    '((?![$+<=>^`|\uff5c])' +
    re.tpl_host_port_fuzzy_strict +
    re.src_path +
    ')';

  re.tpl_link_no_ip_fuzzy =
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' +
    re.src_ZPCc +
    '))' +
    '((?![$+<=>^`|\uff5c])' +
    re.tpl_host_port_no_ip_fuzzy_strict +
    re.src_path +
    ')';
};

export const linkify = new LinkifyIt();
